import React from "react";

export default function BuyAction() {
    return (
        <div className="flex flex-col items-center">
            <span
                className="font-neutra text-[18px] text-grey-02 mb-5 text-center">Sichern Sie sich die kommende Jahrgänge digital.</span>
            <a href="https://dreissigacker-wein.de/shop/selected-nft/"
               className="border rounded-[10px] text-white font-neutra px-4 py-2 disabled:opacity-50 transition-colors">
                <span
                    className="font-neutra text-[14px] uppercase text-white">NFT-Kollektion entdecken</span>
            </a>
        </div>
    )
}